import moment from "moment"

const ReportHelper = {

  getDateRange: (startDate, endDate) => {
    const dateRange = endDate.diff(startDate, "days")

    if (dateRange === 30 && moment().isSame(endDate, 'day') && moment().subtract(30, 'days').isSame(startDate, 'day')) {
      return 30
    } else if (dateRange === 60 && moment().isSame(endDate, 'day') && moment().subtract(60, 'days').isSame(startDate, 'day')) {
      return 60
    } else if (dateRange === 90 && moment().isSame(endDate, 'day') && moment().subtract(90, 'days').isSame(startDate, 'day')) {
      return 90
    } else {
      return "custom"
    }
  }

}

export default ReportHelper